import { AxiosError } from 'axios';
import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';
import { DefaultSeachModel } from '../../../models/ComnModel';
import {
  AccountData,
  AccountTermsData,
  AccountState,
  AccountFormData,
  AgreeTermsData
} from '../models/accountModel';

const REGISTER_REQUEST = 'account/register/REGISTER_REQUEST';
const REGISTER_SUCCESS = 'account/register/REGISTER_SUCCESS';
const REGISTER_FAILURE = 'account/register/REGISTER_FAILURE';

const TERMS_DISPATCH = 'account/terms/TERMS_DISPATCH';

const TERMS_REQUEST = 'account/terms/TERMS_REQUEST';
const TERMS_SUCCESS = 'account/terms/TERMS_SUCCESS';
const TERMS_FAILURE = 'account/terms/TERMS_FAILURE';

// const CRTFYHP_REQUEST = 'account/crtfyhp/CRTFYHP_REQUEST';
// const CRTFYHP_SUCCESS = 'account/crtfyhp/CRTFYHP_SUCCESS';
// const CRTFYHP_FAILURE = 'account/crtfyhp/CRTFYHP_FAILURE';

// const CRTFYHP_CONFIRM_REQUEST = 'account/crtfyhp/CRTFYHP_REQUEST';
// const CRTFYHP_CONFIRM_SUCCESS = 'account/crtfyhp/CRTFYHP_REQUEST';
// const CRTFYHP_CONFIRM_FAILURE = 'account/crtfyhp/CRTFYHP_REQUEST';

export const register = createAsyncAction(
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE
)<AccountFormData, string, AxiosError>();

export const agreeTerms = createAction(TERMS_DISPATCH)<AgreeTermsData[]>();

export const termsList = createAsyncAction(
  TERMS_REQUEST,
  TERMS_SUCCESS,
  TERMS_FAILURE
)<DefaultSeachModel, AccountTermsData[], AxiosError>();

const actions = {
  register,
  termsList,
  agreeTerms
};

export type AccountAction = ActionType<typeof actions>;
